import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconFileFinances';
/** Renders an SVG icon. */
const SvgFileFinances = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 4a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10h-4.5A1.5 1.5 0 0 1 18 8.5V4zm11 1.414L22.586 8H20zM6 5a3 3 0 0 1 3-3h10a1 1 0 0 1 .707.293l6 6A1 1 0 0 1 26 9v18a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 23a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m8-4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1M13 8.5a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1m0 8a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.12 9.745c.318.075.761.222 1.087.548.372.372.573.761.68 1.078a2.3 2.3 0 0 1 .112.591v.02l.001.01v.006S16 12 15 12h1a1 1 0 0 1-1.999.05.74.74 0 0 0-.174-.306 1 1 0 0 0-.165-.052 3 3 0 0 0-.662-.067c-.252 0-.486.026-.662.067a1 1 0 0 0-.165.051.9.9 0 0 0-.23.463c-.015.117-.007.3.232.554.02.009.083.038.216.078.215.063.48.117.805.181l.023.005c.296.06.645.129.954.22.277.081.716.23 1.034.549 1.077 1.077 1.037 2.877 0 3.914-.326.326-.769.473-1.087.548a5 5 0 0 1-1.12.12 5 5 0 0 1-1.12-.12c-.318-.075-.761-.222-1.087-.548a2.8 2.8 0 0 1-.68-1.078 2.3 2.3 0 0 1-.112-.591v-.02l-.001-.01v-.006S10 16 11 16h-1a1 1 0 0 1 1.999-.05.74.74 0 0 0 .174.306c.021.01.073.03.165.052.176.041.41.067.662.067s.486-.026.662-.067c.09-.021.14-.04.164-.05.23-.271.234-.745-.004-1.02-.021-.009-.085-.038-.213-.075a10 10 0 0 0-.805-.182l-.023-.005c-.296-.06-.645-.129-.954-.22-.277-.081-.716-.23-1.034-.549-.691-.69-.932-1.496-.833-2.26.093-.71.466-1.287.833-1.654.326-.326.769-.473 1.087-.548a5 5 0 0 1 1.12-.12c.373 0 .764.037 1.12.12"
      />
    </svg>
  );
};
SvgFileFinances.displayName = displayName;
export default SvgFileFinances;
